import styled from 'styled-components';
import { ModalFooter, ModalHeader } from 'syf-component-library/ui/patterns/SlideInModalPortal';
import { colors, fontSizes, spacing } from 'syf-component-library/defaultTheme';
import query from 'syf-component-library/const/mediaQueries';
export const ModalWrapper = styled.div `
  width: 100%;
  height: 100%;
`;
export const Divider = styled.div `
  width: 100%;
  height: 1px;
  background-color: ${colors.grey};
  margin: 10px 0 16px 0;
`;
export const CustomModalHeader = styled(ModalHeader) `
  h1 {
    font-size: ${fontSizes.root}px;
  }
`;
export const ModalContentWrapper = styled.div `
  display: grid;
  height: calc(100vh - 56px);
  grid-template-rows: 1fr auto;
`;
export const BodyContainer = styled.div `
  overflow-y: auto;
  flex: 1;

  @media ${query.greaterThanLarge} {
    max-width: 1114px;
  }
`;
export const Footer = styled(ModalFooter) `
  max-height: 136px;
  min-height: 0;
  padding: ${spacing.base}px;
  width: 100%;
  display: flex;
  align-items: center;

  @media ${query.lessThanMedium} {
    button:nth-child(1) {
      margin-bottom: 0;
    }
    margin: 0 auto;
  }
`;
